import type { Epic } from 'Flux/index.js'
import { organizationSlice } from 'Flux/Slice/Organization/OrganizationSlice.js'
import { authenticationExpiredOr } from 'Framework/Epic/AuthenticationExpired.js'
import { catchError, filter, mergeMap, of } from 'rxjs'
import type { AjaxError } from 'rxjs/ajax'

export const GetRelatedOrganizationsEpic: Epic = (action$, state$, { [organizationSlice.name]: organization, OrganizationRepository }) =>
  action$.pipe(
    filter(organization.getRelatedOrganizationsRequest.match),
    mergeMap((action) => {
      return OrganizationRepository.listRelatedOrganizations().pipe(
        mergeMap((response) => of(organization.getRelatedOrganizationsSuccess(response))),
        catchError((error: AjaxError) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(organization.getRelatedOrganizationsFailure({ error }))
          })
        )
      )
    })
  )
